export default __webpack_public_path__ + "static/media/best buy.c1cd0c84.svg";